// extracted by mini-css-extract-plugin
export default {"picto":"DossierBase_picto__BgvtH","table":"DossierBase_table__KLaUr","row":"DossierBase_row__6pY2F"};